import React from 'react';
import { DatePicker, Form, Input, InputNumber, Select } from 'antd';
import { useGetExpenseTypes } from 'api/expenses/use-get-expense-types.ts';
import { ClientFormSelect } from 'components/common/client-form-select';
import { ContactFormSelect } from 'components/common/contact-form-select';
import { FormCurrencySelect } from 'components/common/form-currency-select/form-currency-select';
import { validationRules } from './constants';
import styles from './expense-form.module.scss';
import type { IExpenseFormProps } from './types';

export const ExpenseForm: React.FC<IExpenseFormProps> = (props) => {
  const { form, formId, onFinish, initialValues, partnerDisabled = false } = props;

  const { data: expenseTypes } = useGetExpenseTypes();

  const formPartner = Form.useWatch('partner', form);
  const partnerId = formPartner?.value ? Number(formPartner.value) : undefined;

  const handlePartnerChange = (option?: { value: number; label: string }) => {
    form.setFieldsValue({ partner: option, contact: undefined });
  };

  const handleContactChange = (option?: { value: string; label: string }) => {
    form.setFieldValue('contact', option);
  };

  return (
    <Form form={form} id={formId} layout='vertical' initialValues={initialValues} onFinish={onFinish}>
      <Form.Item label='Client number' name='clientNumber' rules={validationRules.clientNumber}>
        <Input placeholder='Client number' />
      </Form.Item>
      <Form.Item label='Type' name='typeId' rules={validationRules.typeId}>
        <Select
          placeholder='Type'
          options={(expenseTypes ?? []).map((type) => ({ value: type.id, label: type.name }))}
        />
      </Form.Item>
      <Form.Item label='Price' name='price' rules={validationRules.price}>
        <InputNumber
          placeholder='Price'
          type='number'
          className={styles.fullWidth}
          addonAfter={<FormCurrencySelect />}
        />
      </Form.Item>
      <Form.Item label='End date' name='endDate' rules={validationRules.endDate}>
        <DatePicker className={styles.fullWidth} />
      </Form.Item>
      <ClientFormSelect
        label='Partner'
        name='partner'
        placeholder='Select partner'
        rules={validationRules.partner}
        handleClientChange={handlePartnerChange}
        currentClientId={initialValues?.partner?.value}
        disabled={partnerDisabled}
        allowClear
      />
      <ContactFormSelect
        label='Contact'
        name='contact'
        placeholder='Select contact'
        rules={validationRules.contact}
        clientId={partnerId}
        handleContactChange={handleContactChange}
        allowClear
      />
    </Form>
  );
};
